import React from "react";
import { Card, cn, Spinner, VisualComponent } from "@siteimprove/fancylib";
import scss from "./page-header-pickers.scss";

export type PageHeaderPickersProps = {
	items: React.ReactNode | React.ReactNode[];
	loading?: boolean;
} & VisualComponent;

export function PageHeaderPickers({
	items,
	loading,
	className,
	...rest
}: PageHeaderPickersProps): JSX.Element {
	return (
		<Card className={cn(scss.container, className)} {...rest}>
			{loading ? (
				<div className={scss.spinner}>
					<Spinner variant="dark" size="medium" />
				</div>
			) : Array.isArray(items) ? (
				items.map((item, index) => (
					<React.Fragment key={`picker-item-${index}`}>
						{item}
						{index < items.length - 1 && <div className={scss.dividerVertical} />}
					</React.Fragment>
				))
			) : (
				items
			)}
		</Card>
	);
}
